import styled from "styled-components";
import { motion } from 'framer-motion';

export const Container = styled(motion.div)`
  background: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  overflow-x: hidden;
  padding: 20px 100px;
  gap: 20px;

  @media screen and (max-width: 425px) {
    padding: 20px  0px;
}

`;

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Wrapper = styled(motion.div)`
flex-grow: 1;
flex-basis: 200;
`

export const Title = styled(motion.h1)`
  font-size: 36px;
  color: #fff;
`;

export const Image = styled(motion.img)`
    width: 100%;
    height: 100%;
`
